// ./src/utils/coverFrame.ts
//
// Which cover videos a frame can be taken from (`CoverFramePicker`). Pure — `check-cover-frame` runs it.

const PROVIDER_RE = /youtube(?:-nocookie)?\.com|youtu\.be|vimeo\.com/i;

/** Can a frame be taken from this cover video? A video FILE (an upload / a direct link) — never YouTube or Vimeo. */
export const canPickFrameFrom = (url: string | null | undefined): boolean => {
  const trimmed = String(url ?? "").trim();

  return /^https?:\/\//i.test(trimmed) && !PROVIDER_RE.test(trimmed);
};
